import { render } from "./textshow.vue?vue&type=template&id=0000576e&scoped=true"
import script from "./textshow.vue?vue&type=script&lang=js"
export * from "./textshow.vue?vue&type=script&lang=js"

import "./textshow.vue?vue&type=style&index=0&id=0000576e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0000576e"]])

export default __exports__